import { getCookie } from '@rategravity/frontend/modules/hubspot';
import Immutable from 'immutable';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import React from 'react';
import { chooseDeck } from '../../decks';
import prefill from '../../modules/prefill';
import { sanitizeModel } from '../../modules/sanitizer';
import { muiTheme } from '../../shared/theme';
import { saveToSession } from '../card/session-card';
import { Deck, percentComplete } from '../deck';
import Footer from '../footer';
import { AnonHeader } from '../header';

const style = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#F9F9F9'
  }
};

const statusString = ({ cardGraph, saving, model }) => {
  if (saving) {
    return 'Saving...';
  }

  const percent = percentComplete(cardGraph, { model });
  const motivationFactor = 3;
  return percent > 0 ? `${(percent + motivationFactor).toFixed(0)}% complete` : '';
};

export default (scenario, actionPipe) =>
  class extends React.Component {
    componentWillMount() {
      prefill({
        viewer: this.props.viewer,
        updateLoan: this.props.updateLoan,
        updateBorrower: ({ borrower, fields }) => {
          // ensure the session is updated too
          saveToSession(Immutable.Map().set('borrower', fields));
          this.props.updateBorrower({ borrower, fields });
        },
        scenario,
        hubspotToken: getCookie(),
        url: window.location.search,
        actionPipe
      });
    }

    header(status) {
      return <AnonHeader status={status} scenario={scenario} />;
    }

    render() {
      const { updateBorrower, updateLoan, saving, viewer, location } = this.props;

      const borrower = viewer.primaryBorrower;
      const coborrower = viewer.activeLoan.coborrower.edges[0].node;
      const loan = viewer.activeLoan;

      const model = sanitizeModel(Immutable.fromJS({ borrower, coborrower, loan, location }));

      const onSubmit = (overlay) => {
        overlay = sanitizeModel(overlay);
        if (overlay.has('borrower')) {
          updateBorrower({ borrower, fields: overlay.get('borrower') });
        }

        if (overlay.has('coborrower')) {
          updateBorrower({
            borrower: coborrower,
            fields: overlay.get('coborrower')
          });
        }

        if (overlay.has('loan')) {
          updateLoan({ loan, fields: overlay.get('loan') });
        }
      };

      const cardGraph = chooseDeck({ scenario });

      return (
        <MuiThemeProvider muiTheme={muiTheme}>
          <div style={style.page}>
            {this.header(statusString({ cardGraph, saving, model }))}
            <Deck
              cardGraph={cardGraph}
              model={model}
              onSubmit={onSubmit}
              onComplete={this.props.onComplete}
              actionPipe={this.props.actionPipe}
            />
            <Footer />
            {React.Children.map(this.props.children, (child) =>
              child ? React.cloneElement(child, { model }) : null
            )}
          </div>
        </MuiThemeProvider>
      );
    }
  };



// WEBPACK FOOTER //
// ./src/components/app/index.js